import React, { useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { connect } from 'react-redux'
import { getAllPeriods } from '../../../redux/actions/periodActions'
import PeriodsList from '../../../components/PeriodsList'
import { BackListButton } from '../../../components/BackListButton'
import CreatePeriodButton from '../../../components/CreatePeriodButton'

const ListPeriods = ({ periods, getAllPeriods }) => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    getAllPeriods()
  }, [])

  return (
    <Container fluid="xl" className='mt-4 mb-3'>
      <Row>
        <Col className='d-flex justify-content-between align-items-center bg-white'>
          <h1 className="mt-4 mb-1">Listado de Periodos</h1>
        </Col>
        <Col className='d-flex justify-content-end align-items-center bg-white'>
          <CreatePeriodButton />
          <BackListButton />
        </Col>
      </Row>
      <hr/>
      <Row>
        <Col className='bg-white'>
          <PeriodsList
            records={periods}
          />
        </Col>
      </Row>
    </Container>
  )
}

export default connect(({ periodsReducer }) => ({ periods: periodsReducer }),{ getAllPeriods })(ListPeriods)